<template>
    <transition-group name="slide-fade">

        <form-feedback
        key="feedback"
        v-if="achieved" />

        <section 
        key="form"
        v-else>

            <form-progress class="mb-7" />
            
            <div class="row">

                <form-row 
                v-for="row in rows"
                :key="'row-'+row.id" 
                :row="row" />

            </div> <!-- /.row -->


            <form-section
            v-for="section in sections"
            :key="'section-'+section.id"
            :section="section" />

            <div class="mt-8 d-flex justify-content-end">

                <loading-button 
                :loading="loading"
                :disabled="stop || progress.percentage != 100"
                @click="submit()"
                class="d-inline-block btn btn-primary">
					{{ $t('form.Send') }}
                </loading-button>

            </div> <!-- /.d-flex -->

        </section>
    
    </transition-group>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        data() {
            return {
                loading: false
            }
        },

        computed: {

            ...mapState({
                achieved: state => state.form.achieved
            }),

            ...mapGetters('form', [
                'rows',
                'sections',
                'stop',
                'progress'
            ])

        },

        methods: {

            submit() {
                this.loading = true

                this.$store
                .dispatch('form/submitForm')
                .then(() => { 
                    this.loading = false 
                })
                .catch(() => {
                    this.loading = false
                    this.$flash(this.$t('app.An error has occured'))
                })
            }
            
        }

    }

</script>